import { apiClient } from '../config/api-config';

/**
 * Backend KYB Status Response
 * Returned by GET /api/v1/my-account/kyb-status
 */
export interface BackendKybStatusResponse {
  status: string;
  reviewerComments: string | null;
  rejectionReason: string | null;
  nextAction: string | null;
  kybAttemptId: string;
  attemptNumber: number;
}

/**
 * KYB Status API service
 * Handles fetching detailed KYB status information including rejection reasons
 */
export const kybStatusService = {
  /**
   * Fetch detailed KYB status from the API
   * Used in router loaders to get rejection reason when KYB status is REJECTED
   */
  getKybStatus: async (): Promise<BackendKybStatusResponse> => {
    const response = await apiClient.axios.get<BackendKybStatusResponse>(
      '/my-account/kyb-status'
    );
    return response.data;
  },
};

export default kybStatusService;
